import { urlRootPath } from 'helpers/urlPath'
import { SPORT_URL_PART } from 'pages/Sport/_constants/SPORT_URLS'
import { AUTH_URL_PART } from 'pages/Auth/URL'

export const getAuthPageUrl = (after_auth_url) => {
  const auth_url = urlRootPath(SPORT_URL_PART, AUTH_URL_PART);
  const back_url = typeof after_auth_url === 'string' ? after_auth_url : window.location.href;

  return `${auth_url}?back_url=${encodeURIComponent(back_url)}`;
};

export const redirectToAuthPage = (after_auth_url) => {
  window.location.href = getAuthPageUrl(after_auth_url);
};
